/**
 * True when the browser reports no network connectivity. Used to mark a
 * `status === 0` failure as a benign offline abort rather than an actionable
 * transport error (CORS/DNS/dropped TCP) that happened while online.
 *
 * Single source of truth for the offline signal that both `HttpErrorService`
 * and `defaultHandleHttpError` stamp onto `ApiError.offline`, which Sentry's
 * `beforeSend` benign-abort filter (`isBenignClientAbort`) keys on. Keeping one
 * definition prevents the two error paths from drifting and suppressing (or
 * reporting) the same failure inconsistently.
 *
 * Guarded for non-browser contexts where `navigator` is undefined — there we
 * cannot assert the client is offline, so we conservatively report `false`.
 */
export function isOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false;
}
